import { render, staticRenderFns } from "./SkeletonLoaderReview.vue?vue&type=template&id=1982750f&scoped=true&"
import script from "./SkeletonLoaderReview.vue?vue&type=script&lang=ts&"
export * from "./SkeletonLoaderReview.vue?vue&type=script&lang=ts&"
import style0 from "./SkeletonLoaderReview.vue?vue&type=style&index=0&id=1982750f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1982750f",
  null
  
)

export default component.exports